module.exports = __webpack_public_path__ + "img/vic-logo.90e8d36e.svg";